exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-c19a88fe] {\r\n  background: #fff;\r\n  padding: 10px 16px;\n}\n.pagination-container.hidden[data-v-c19a88fe] {\r\n  display: none;\n}\r\n", ""]);

// exports
